































import { Vue, Component } from 'vue-property-decorator'
@Component({
  name: 'FilesApp'
})
export default class extends Vue {
  showNav: boolean = true

  get editPage() {
    const activeArr: string[] = ['AddApp', 'VipBoard']
    return activeArr.includes(this.$route.name as string)
  }
}
